export default "__VITE_ASSET__Ch5fWv2T__"